import { useEffect } from "react";
import Lenis from "lenis";

/**
 * SmoothScroll — initialises a Lenis instance to give the page a buttery,
 * inertial scroll feel reminiscent of high-end product sites (ltx, awwwards-tier).
 * Drop this component once near the page root.
 */
export const SmoothScroll = () => {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.15,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            wheelMultiplier: 1.0,
            touchMultiplier: 1.4,
        });

        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);

        // intercept in-page anchor clicks for smooth scrolling
        const onClick = (e) => {
            const a = e.target.closest && e.target.closest('a[href^="#"]');
            if (!a) return;
            const id = a.getAttribute("href");
            if (!id || id === "#") return;
            const el = document.querySelector(id);
            if (!el) return;
            e.preventDefault();
            lenis.scrollTo(el, { offset: -64, duration: 1.3 });
        };
        document.addEventListener("click", onClick);

        return () => {
            cancelAnimationFrame(rafId);
            document.removeEventListener("click", onClick);
            lenis.destroy();
        };
    }, []);

    return null;
};

export default SmoothScroll;
